import { gql } from '@apollo/client';

export const fetchLinkedEntitlementsPPC = gql`
  query fetchLinkedEntitlementsPPC(
    $id: String!
    $searchLinkedEntitlementParams: SearchLinkedEntitlementParams!
    $transactionAccountId: String
  ) {
    entitlementDetails(id: $id, filters: { transactionAccountId: $transactionAccountId }) {
      id
      transactionAccountId
      isAddOn
      linkedEntitlements(searchLinkedEntitlementParams: $searchLinkedEntitlementParams) {
        id
        entitlementId
        billingFrequency
        cloudSiteHostname
        cloudSiteId
        productId
        createdDate
        edition
        unitCount
        provisioningStatus
        baseProduct
        billingStatus
        billedUsers
        entitlementNumber
        productName
        billingCycle
        offeringId
        subscriptionId
        billingGroupId
        parentSen
        userTier
        transactionAccountId
        latestPeriodEndDate
        isFutureDatedSubscription
        futureDatedStartTimestamp
        lastPeriodStartDate
        isApp
        isAddOn
        isSandbox
        activeUsers
        subscriptionTimestamps {
          firstTrialStartTimestamp
          lastTrialEndTimestamp
        }
        offering {
          pricingType
          relationshipRequirements {
            level
            side
            type
          }
        }
        relatesFromEntitlements {
          entitlementId
          relationshipType
        }
        relatesToEntitlements {
          entitlementId
          relationshipType
        }
        trial
        logoId
        nextBillEstimate {
          total
          currency
        }
        linkedAppsId
        linkedAddOnsId
        chargeElement
        optedQuantitySource
        provisionedResourceDetails {
          organisationName
          organisationId
        }
        pauseBilling {
          startTimestamp
          endTimestamp
        }
      }
    }
  }
`;
